import React from 'react'
import uniqueId from 'lodash/uniqueId'
import cn from 'classnames'

import './styles.scss'

const bc = 'check-box-universal'

// @Deprecated please use CheckBoxUniversalNew
// Here is incorrect logic because we must try to use native abilities selects and we mustn't provide 'marked' option.
// Browser will do all work without us if we provide correct attributes
// Only provide value true or false|undefined. Please see example with OrganizationForm with CountriesCodes
const CheckBoxUniversal = ({ input: { marked, ...props }, disabledComponent, enabledComponent, className }) => {
  const id = uniqueId(bc)

  return (
    <div className={cn(bc, className)}>
      <label htmlFor={id}>
        {marked ? enabledComponent : disabledComponent}
        <input type="checkbox" id={id} {...props} />
      </label>
    </div>
  )
}

export default CheckBoxUniversal
